var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"display-message"},[_c('img',{attrs:{"src":_vm.getLogoUrl(_vm.charging),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.retry)?_c('router-link',{staticClass:"retry-link",attrs:{"to":{name: 'charging', params: {sale: _vm.sale, charging: _vm.charging, id: _vm.charging.code}}}},[_vm._v(_vm._s(_vm.translation.home.tryAgain))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e3268b5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ChargingFeedback.vue
// module id = 850
// module chunks = 0